import { memo, useEffect } from 'react'
import { logTable } from 'assets/TableHeader'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCell'
import { organismLog } from 'utils/logUtil'
import { logList } from 'utils/requestUtil'
import { getTimestampFromDate, getTimestampFromNumber } from 'utils/dateUtil'
import { zeroPadding } from 'utils/stringUtil'
import { useUser } from 'hooks/useLogin'

type Props = {
  log: logList
}
const width = logTable.width
const manualMode = process.env.REACT_APP_MANUAL_MODE === '1'

const O_TableRowLog = ({ log }: Props) => {
  useEffect(() => organismLog('O_TableRowLog'), [])
  const [isJapell] = useUser()

  const addDate = new Date(getTimestampFromNumber(Number(String(log.ADD_YMD) + zeroPadding(log.ADD_HNS, 6))))
  const ADD_YMD = getTimestampFromDate(addDate, 'YYYY/MM/DD')
  const ADD_HNS = getTimestampFromDate(addDate, 'hh:mm:ss')

  const TOROKU_KBN = (() => {
    if (log.TOROKU_KBN === 0) return '登録'
    if (log.TOROKU_KBN === 1) return '削除'
    if (log.TOROKU_KBN === 2) return '更新'
    return ''
  })()

  return (
    <>
      {/* 日付 */}
      <M_TableCell
        category="data" //
        width={width.ADD_YMD}
        align={'left'}
        title={ADD_YMD}
        data={ADD_YMD}
      />
      {/* 時間 */}
      <M_TableCell
        category="data" //
        width={width.ADD_HNS}
        align={'left'}
        title={ADD_HNS}
        data={ADD_HNS}
      />
      {/* 登録：削除 */}
      <M_TableCell
        category="data" //
        width={width.TOROKU_KBN}
        align={'left'}
        title={TOROKU_KBN}
        data={TOROKU_KBN}
      />
      {/* 事業所CD */}
      {isJapell ? (
        <M_TableCell
          category="data" //
          width={width.JIGYO_CD}
          align={'left'}
          title={log.JIGYO_CD}
          data={log.JIGYO_CD}
        />
      ) : (
        <></>
      )}
      {/* 事業所名 */}
      {isJapell ? (
        <M_TableCell
          category="data" //
          width={width.JIGYO_NM}
          align={'left'}
          title={log.JIGYO_NM}
          data={log.JIGYO_NM}
          blackout={manualMode}
        />
      ) : (
        <></>
      )}
      {/* 得意先CD */}
      <M_TableCell
        category="data" //
        width={width.TOKUI_CD}
        align={'left'}
        title={log.TOKUI_CD}
        data={log.TOKUI_CD}
      />
      {/* 得意先名 */}
      <M_TableCell
        category="data" //
        width={width.TOKUI_NM}
        align={'left'}
        title={log.TOKUI_NM}
        data={log.TOKUI_NM}
        blackout={manualMode}
      />

      {/* 店舗CD */}
      <M_TableCell
        category="data" //
        width={width.TEN_CD}
        align={'left'}
        title={log.TEN_CD}
        data={log.TEN_CD}
      />
      {/* 店舗名 */}
      <M_TableCell
        category="data" //
        width={width.TEN_NM}
        align={'left'}
        title={log.TEN_NM}
        data={log.TEN_NM}
        blackout={manualMode}
      />
      {/* メールアドレス */}
      <M_TableCell
        category="data" //
        width={width.MAIL}
        align={'left'}
        title={log.MAIL}
        data={log.MAIL}
        blackout={manualMode}
      />
      {/* 氏名 */}
      <M_TableCell
        category="data" //
        width={width.NAME}
        align={'left'}
        title={log.NAME}
        data={log.NAME}
        blackout={manualMode}
      />
      {/* 登録者メール */}
      <M_TableCell
        category="data" //
        width={width.ADD_MAIL}
        align={'left'}
        title={log.ADD_MAIL}
        data={log.ADD_MAIL}
        blackout={manualMode}
      />
      {/* 登録者名 */}
      <M_TableCell
        category="data" //
        width={width.ADD_NAME}
        align={'left'}
        title={log.ADD_NAME}
        data={log.ADD_NAME}
        blackout={manualMode}
      />
    </>
  )
}

export default memo(O_TableRowLog)
